import "./SoundAndLighting.module.css";
import Header from "@/reusable_sections/Header";
import AudioEquipmentOverview from "./sections/AudioEquipmentOverview";
import LightingDesignGallery from "./sections/LightingDesignGallery";
import RequestAQuote from "./sections/RequestAQuote";
import Footer from "@/reusable_sections/Footer";
export default function SoundAndLightingPage() {
  return <div>
      <Header />
      <AudioEquipmentOverview />
      <LightingDesignGallery />
      <RequestAQuote />
      <Footer />
    </div>;
}